import React from 'react'
import {Icon} from '@chakra-ui/react'

const CartIcon = (props) => {
    return (
        <Icon viewBox="0 0 40 40" {...props}>
            <path
                d="M33.7763 26.9253H14.341C13.7417 26.9253 13.2162 26.5196 13.0595 25.9388L7.49072 4.84395H1.92198C1.41489 4.84395 1 4.42906 1 3.92198C1 3.41489 1.41489 3 1.92198 3H7.89638C8.49567 3 9.0212 3.40567 9.17793 3.98651L10.7545 9.94248H37.6762C38.0911 9.94248 38.4783 10.1361 38.7273 10.4588C38.9762 10.7907 39.0592 11.2056 38.9578 11.6113L35.0578 25.948C34.9011 26.5196 34.3755 26.9253 33.7763 26.9253ZM14.7467 25.0813H33.3798L36.994 11.7864H11.2339L14.7467 25.0813Z"
                fill="currentColor"
            />
            <path
                d="M16.2495 36.4585C17.8942 36.4585 19.2275 35.1253 19.2275 33.4806C19.2275 31.8359 17.8942 30.5026 16.2495 30.5026C14.6048 30.5026 13.2715 31.8359 13.2715 33.4806C13.2715 35.1253 14.6048 36.4585 16.2495 36.4585Z"
                fill="currentColor"
            />
            <path
                d="M31.5639 36.4585C33.2086 36.4585 34.5419 35.1253 34.5419 33.4806C34.5419 31.8359 33.2086 30.5026 31.5639 30.5026C29.9192 30.5026 28.5859 31.8359 28.5859 33.4806C28.5859 35.1253 29.9192 36.4585 31.5639 36.4585Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default CartIcon
